export default {
  cl: () => require('./chile').default
};
